<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.30664" y="1.36682" width="12.3867" height="1.1" rx="0.4" fill="#333333"/>
<rect x="1.30664" y="5.38293" width="12.3867" height="2.13115" rx="0.6" fill="#333333"/>
<rect x="1.30664" y="10.4302" width="12.3867" height="3.20288" rx="0.8" fill="#333333"/>
</svg>
